import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import CreateTermCondition from './../createtc';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import Util from './../../../../shared/util/util';

export default {
	name: 'listingtc',
	components: {
		BasicSelect,
		CustomExpandableTable,
		Pagination,
		VueElementLoading,
		CreateTermCondition
	},
	props: [],
	data() {
		return {
			tableColumn: ['Template Name', 'Template Description','Created By','Created Date','Last Modified By','Last Modified Date','Status','Action'],
			tableItems: [],
			addtc: false,
			templateName: '',
			templateNameSearch: '',
			type: 'TERMS_CONDITION',
			isLoading: false,
			currentPage: 1,
			apiListingData: [],
			totalCount: 0,
			innerTableColumn: [],
			totalPage: 0,
			offset: 0,
			pageLimit: CONSTANT.PER_PAGE_DATA,
			selectedEditRow: [],
			billingCycle: '',
			pod: '',
			date1: '',
			date2: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			advancePayment: '',
			creditAlert: '',
			paymentmode: [],
			liabilityAmount: '',
			isViewLoading:false,
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false},
			status:"",
			statusSearch:"",
			statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
		}
	},
	computed: {},
	mounted() {
		this.getTCList();
	},
	methods: {
		selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		showAddForm() {
			this.addtc = true;
		},
		eventFromParent() {
			this.addtc = false;
			this.selectedEditRow = [];
			this.currentPage = 1;
			this.offset = 0;
			this.getTCList();
		},
		onPageChange(page) {
			this.currentPage = page;
			this.offset = (page - 1) *this.pageLimit
			this.getTCList();
		},
		getCustomTableEvent(event) {
			if(event.actionType=="active"){
				this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
				this.activeAction(event);
			 }).catch((err)=>{
				 console.log(err)
			 });
		 }else if(event.actionType=="inactive"){
				this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
				this.activeAction(event);
			 }).catch((err)=>{
				 console.log(err)
			 })
			}
			if (event.actionType == "edit") {
				let selectedEditRow = this.apiListingData.filter(function(Items) {
					return Items.id == event.id;
				});
				this.selectedEditRow = selectedEditRow[0];
				this.addtc = true;
			}else if (event.actionType == "view") {
				let selectedEditRow = this.apiListingData.filter(function(Items) {
					return Items.id == event.id;
				});
				this.getTCDetails(selectedEditRow[0]);
			}
		},
		async getTCDetails(data) {
			this.isViewLoading = true;
			this.billingCycle = data.billingcycle;
			if( data.podhardcopyrequired==1){
				this.pod = "Yes";
			}else{
				this.pod = "No";
			}
			this.podCharge = data.podhardcopycharges;
			if(data.billingcycle == 1){
				this.billingCycle = "Monthly";
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = '';
			}else if(data.billingcycle == 2){
				this.billingCycle = "Fortnightly";
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = data.billsubmissionlastdate.cycle2;
			}else{
				this.billingCycle = "Weekly";
			}

			this.creditPeriod = data.creditperioddays;
			this.creditLimit = data.creditlimit;
			this.advancePayment = data.ftladvancepayment;
			this.creditAlert = data.creditlimitalert;
			let tempArr = [];
			if(data.paymentmode.includes("1")){
				tempArr.push("Cheque");
			}
			if(data.paymentmode.includes("2")){
				tempArr.push("Demand Draft");
			}
			if(data.paymentmode.includes("3")){
				tempArr.push("RTGS");
			}
			this.paymentmode = tempArr.join(", ");
			this.liabilityAmount = data.maxliability;
			this.isViewLoading = false;
		},
		resetSearchfilter() {
			this.templateName = '';
			this.templateNameSearch = '';
			this.status= "";
			this.statusSearch= "";
			this.statusitem = {};
			this.currentPage = 1;
			this.isLoading = false
			this.getTCList()
		},
		async activeAction(data){
			try {
				this.isLoading = true;
			  var item = this.apiListingData.find(item => item.id === data.id);
				var isactivestatus = item.status == 0 ? 1 : 0
				let inputPayload = {
					"id": data.id,
					"type": this.type,
					"status": isactivestatus
				}
				let result = await MasterService.changeStatus(inputPayload)
				if(result.data.code == 200){
					if(result.data.data[0].status == 0){
					this.$alert("T&C  Activated Successfully!!", this.templateNameSearch, "success");
				}else{
					this.$alert("T&C Inactivated Successfully!!", this.templateNameSearch, "success");
				 }
					this.getTCList();
					this.isLoading = false;
				}
			} catch(err){
				console.log(err);
			}
		},
		serachFilter() {
			this.currentPage = 1;
			this.offset = 0;
			this.templateNameSearch = this.templateName;
			this.statusSearch = this.status;
			this.getTCList();
		},
		async getTCList() {
			try {
				let payload = {
					offset: this.offset,
					limit: this.pageLimit
				}
				if (this.templateNameSearch) {
					payload.termsconditionname = this.templateNameSearch.trim()
				}
				if(this.statusSearch!=""){
				  payload.status = this.statusSearch;
				}
				this.isLoading = true
				let result = await MasterService.gettermconditionListing(payload)
				this.isLoading = false
				this.totalCount = result.data.data.count;
				this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
				this.apiListingData = result.data.data.rows
				this.tableItems = result.data.data.rows.map((el) => {
					return {
						'id': el.id,
						'Template Name': el.termsconditionname,
						'Template Description': el.termsconditiondscription,
						'Created By':el.createdby,
						'Created Date':Util.displayDateTimeFormat(el.createddate),
						'Last Modified By':el.lastmodifiedby,
					  'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
						'Status': el.status,
						'Action': 'Need To Check1',
					}
				})
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/tc/listingtc/listingtc.component.js